import palette from '../palette';

export default {
  styleOverrides: {
    root: {
      borderCollapse: 'separate',
      borderSpacing: 0,
      '& .MuiTableCell-root': {
        borderBottom: `1px solid ${palette.divider}`,
      },
      '& .MuiTableHead-root .MuiTableCell-root': {
        borderBottom: `2px solid ${palette.divider}`,
        backgroundColor: palette.background.default,
      }
    }
  }
};
